import {getExpedientQueryOptions} from "@project/application/sales/expedients";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";
import {z} from "zod";

import {routeMessages} from "../../../../../messages/routes.messages";

import {ExpedientPage} from "./-page/expedient.page";
import {ExpedientPending} from "./-page/expedient.pending";

export const Route = createFileRoute("/_app/sales/expedients/$expedientId")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, params}) =>
    queryClient.ensureQueryData(getExpedientQueryOptions(z.uuid().parse(params.expedientId))),
  pendingComponent: ExpedientPending,
  staticData: {
    meta: {
      getLabel: (p: Record<string, string>, data?: unknown) => {
        if (
          !data ||
          typeof data !== "object" ||
          !("expedientId" in data) ||
          data.expedientId !== p["expedientId"]
        )
          return undefined;
        if ("number" in data && typeof data.number === "string") return data.number;
        return "alias" in data && typeof data.alias === "string" ? data.alias : undefined;
      },
      getLabelDescriptor: (p: Record<string, string>) => ({
        id: routeMessages.expedientById.id,
        values: {expedientId: p["expedientId"]},
      }),
    },
  },
});

function RouteComponent() {
  const {expedientId} = Route.useParams();
  return <ExpedientPage expedientId={expedientId} />;
}
